import styled from 'styled-components'

export const InputRow = styled.div`
	display: flex;
	column-gap: 12px;
`
